import { Input, Output, SimpleChanges } from '@angular/core';
import { Component, EventEmitter, OnInit } from '@angular/core';
import { ngbModalOptions } from 'shared/constant';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadDocumentComponent } from './upload-document/upload-document.component';
import { EAndO } from '../../../../../models/eando/eando.model';
import { Subscription } from 'rxjs';
import { EAndOAttachment } from '../../../../../models/eando/eando-attachment';
import { EandoService } from '../../../../../api-services/eando.service';
import { SharedService } from '../../../../../services';
import { EAndOCommonService } from '../../../../../services/eando-common.service';
import { ConfirmDialogComponent } from 'components/shared-component/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-side-attachments-error-omissions',
  templateUrl: './side-attachments-error-omissions.component.html',
  styleUrls: ['./side-attachments-error-omissions.component.css']
})
export class SideAttachmentsErrorOmissionsComponent implements OnInit {

  @Input() archive: boolean;
  @Input() sidePanelData;
  @Output() updateAttachmentEvent = new EventEmitter<number>();
  @Output() updateArchiveAttachmentEvent = new EventEmitter<number>();
  @Input() eandO: EAndO

  selectedFiles: FileList;
  selectedRecordId:number = null;
  private subscription: Subscription;

  eandoAttachments: EAndOAttachment[] = [] as EAndOAttachment[];

  constructor(private modalService: NgbModal, private eandoService: EandoService,
    private sharedService: SharedService, private eandoCommonService: EAndOCommonService) { }

  ngOnInit(): void {
    this.updateAttachments();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.ngOnInit();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit() {
    if (this.archive) {
      this.subscription = this.eandoCommonService.archiveTabReloadReloadObs.subscribe(() => {
        this.updateAttachments();
      });
    }
    else {
      this.subscription = this.eandoCommonService.activeTabReloadReloadObs.subscribe(() => {
        this.updateAttachments();
      });
    }
  }

  archiveAttachment(eandOAttachmentId) {
    this.eandoService.archiveEandOAttachment(eandOAttachmentId).subscribe(response => {
      this.updateAttachments();
      this.sharedService.showToastMessage("Attachment archived successfully.");
      if (this.archive) {
        this.eandoCommonService.notifyActiveTabToReload();
      }
      else {
        this.eandoCommonService.notifyArchiveTabToReload();
      }
    });
  }

  unarchiveAttachment(eandOAttachmentId) {
    this.eandoService.unarchiveEandOAttachment(eandOAttachmentId).subscribe(response => {
      this.updateAttachments();
      this.sharedService.showToastMessage("Attachment unarchived successfully.");
      if (this.archive) {
        this.eandoCommonService.notifyActiveTabToReload();
      }
      else {
        this.eandoCommonService.notifyArchiveTabToReload();
      }
    });
  }

  deleteAttachment(eandOAttachment) {
    var modalData = {
          title: "Delete Attachment",
          prompt: `Are you sure you want to delete attachment - <span class="bold-500">${eandOAttachment.fileName}</span> ?`
        }
        const modalRef = this.modalService.open(ConfirmDialogComponent, ngbModalOptions);
        modalRef.componentInstance.modalData = modalData;
    
        modalRef.result.then(data => {
          if (data) {
            this.eandoService.deleteEandOAttachment(eandOAttachment.eandOAttachmentId).subscribe(response => {
            this.updateAttachments();
            this.eandoCommonService.notifyActiveTabToReload();
            this.sharedService.showToastMessage("Attachment deleted successfully.");
          });
          }
        });

  }

  updateAttachments() {
    this.eandoService.getEAndOAttachments(this.eandO.eandOId, this.archive).subscribe(response => {
      this.eandoAttachments = response.map(obj => ({
        ...obj,
        createdDate: this.sharedService.convertUTCTimeToLocalTime(obj.createdDate),
        archivedDate: this.sharedService.convertUTCTimeToLocalTime(obj.archivedDate)
      }))

      if (!this.archive) {
        this.updateAttachmentEvent.emit(this.eandoAttachments.length);
      }
      else {
        this.updateArchiveAttachmentEvent.emit(this.eandoAttachments.length);
      }
    });
  }

  downloadFile(eandOAttachmentId) {
    this.sharedService.showLoader();
    this.eandoService.downloadEAndOFile(eandOAttachmentId).subscribe(response => {
      this.sharedService.hideLoader();
      let byteCharacters = atob(response.response);
      let byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++)
        byteNumbers[i] = byteCharacters.charCodeAt(i);

      let byteArray = new Uint8Array(byteNumbers);
      let blob = new Blob([byteArray], { type: response.contentType });

      if (response.contentType === "application/pdf") {
        var blobURL = URL.createObjectURL(blob);
        window.open(blobURL);
      }
      else {
        var blobURL = window.URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.download = response.fileName;
        anchor.href = blobURL;
        anchor.click();
      }
    }),
      (error: any) => {
        console.log(error);
        this.sharedService.hideLoader();
      };
  }

  selectFiles(event) {
    this.selectedFiles = event.target.files;
    this.openUploadPopup();
  }

  bytesToMegabytes(bytes: number): string {
    const KB = 10 * 1024; // To convert byte into 10 kb
    const bytesInMB = 1024 * 1024;
    //If less than 10 kb 
    if (bytes < KB) return (bytes / 1024).toFixed(2) + ' KB';
    return (bytes / bytesInMB).toFixed(2) + ' MB';
  }

  openUploadPopup() {
    const modalRef = this.modalService.open(UploadDocumentComponent, ngbModalOptions);
    modalRef.componentInstance.selectedFiles = this.selectedFiles;
    modalRef.componentInstance.eandOId = this.eandO.eandOId;
    modalRef.componentInstance.eandoAttachments = this.eandoAttachments;
    modalRef.result.then(data => {
      if (data) {
        this.updateAttachments();
      }
    })
  }

}
